import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  emailRegex = /^\s*(([^<>()\[\]\\.,;:\s@"\u0600-\u06FF]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;

  constructor() { }

  // to check if the end time is greater than the start time
  timeOrderValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {

    const startOpening = group.get('branch_opening_from')?.value;
    const endOpening = group.get('branch_opening_to')?.value;
    const startTime = group.get('from')?.value;
    const endTime = group.get('to')?.value;

    if (startTime && (startTime < startOpening) ) {
      return { startTimeInvalid: true };
    } else if (endTime && (endTime > endOpening)) {
      return { endTimeInvalid: true };
    }

    return null;
  };
}
